"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentWidgetMixin = void 0;
var CardName_1 = require("../CardName");
var ResourceType_1 = require("../ResourceType");
exports.PaymentWidgetMixin = {
    'name': 'PaymentWidgetMixin',
    'methods': {
        getMegaCreditsMax: function () {
            return Math.min(this.player.megaCredits, this.$data.cost);
        },
        getCssClassFor: function (action, target) {
            var currentValue = this[target];
            var maxValue = this.player[target];
            var disablingLimit = (action === '<') ? 0 : maxValue;
            if (currentValue === disablingLimit)
                return 'is-disabled';
            return 'is-primary';
        },
        getResourceRate: function (resourceName) {
            var rate = 1;
            if (resourceName === 'titanium') {
                rate = this.player.titaniumValue;
            }
            else if (resourceName === 'steel') {
                rate = this.player.steelValue;
            }
            else if (resourceName === 'microbes') {
                rate = 2;
            }
            else if (resourceName === 'floaters') {
                rate = 3;
            }
            return rate;
        },
        reduceValue: function (target, to) {
            var currentValue = this[target];
            if (currentValue === 0)
                return;
            var realTo = Math.min(to, currentValue);
            this[target] -= realTo;
            if (target === 'megaCredits' || realTo === 0)
                return;
            this.setRemainingMCValue();
        },
        addValue: function (target, to, max) {
            var currentValue = this[target];
            var maxValue = max !== null && max !== void 0 ? max : this.player[target];
            if (target === 'megaCredits') {
                maxValue = this.getMegaCreditsMax();
            }
            if (target === 'microbes')
                maxValue = this.playerinput.microbes;
            if (target === 'floaters') {
                maxValue = this.playerinput.floaters;
                if (this.isStratosphericBirdsEdgeCase())
                    maxValue--;
            }
            if (currentValue === maxValue)
                return;
            var realTo = (currentValue + to <= maxValue) ? to : maxValue - currentValue;
            this[target] += realTo;
            if (target === 'megaCredits' || realTo === 0)
                return;
            this.setRemainingMCValue();
        },
        setRemainingMCValue: function () {
            var remainingMC = this.$data.cost -
                this['heat'] -
                this['titanium'] * this.getResourceRate('titanium') -
                this['steel'] * this.getResourceRate('steel') -
                this['microbes'] * this.getResourceRate('microbes') -
                this['floaters'] * this.getResourceRate('floaters');
            this['megaCredits'] = Math.max(0, Math.min(this.getMegaCreditsMax(), remainingMC));
        },
        setMaxValue: function (target, max) {
            var currentValue = this[target];
            var cardCost = this.$data.cost;
            var amountHave = max !== null && max !== void 0 ? max : this.player[target];
            var amountNeed = cardCost;
            if (['titanium', 'steel', 'microbes', 'floaters'].includes(target)) {
                amountNeed = Math.floor(cardCost / this.getResourceRate(target));
            }
            if (target === 'microbes')
                amountHave = this.playerinput.microbes;
            if (target === 'floaters') {
                amountHave = this.playerinput.floaters;
                if (this.isStratosphericBirdsEdgeCase())
                    amountHave--;
            }
            while (currentValue < amountHave && currentValue < amountNeed) {
                this.addValue(target, 1, max);
                currentValue++;
            }
        },
        isStratosphericBirdsEdgeCase: function () {
            if (this.$data.card.name === CardName_1.CardName.STRATOSPHERIC_BIRDS) {
                var playedCards = this.player.playedCards;
                var cardsWithFloaters = playedCards.filter(function (card) { return card.resourceType === ResourceType_1.ResourceType.FLOATER && card.resources; });
                return cardsWithFloaters.length === 1;
            }
            return false;
        },
    },
};
//# sourceMappingURL=PaymentWidgetMixin.js.map